// Footer.js
import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-[#212429] text-white py-6 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">

        {/* Copyright */}
        <div className="mt-8 pt-4 border-t border-gray-700 text-center text-sm">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Contact Information */}
          <div className="text-center md:text-left">
            <p className="mb-2">Email: <a href="mailto:info@berryclub.in">info@berryclub.in</a> | Phone: <a href="tel:+917738040380">(+91)7738040380</a></p>
          </div>

        </div>

          <p>© {new Date().getFullYear()} <a href="https://novecta.in">Novecta Technologies Private Limited</a>. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;